var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilters(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 3.56641H3.56667",
    stroke: "#6679A9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 12.1221H6.13333",
    stroke: "#6679A9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8333 12.1221L16.4 12.1221",
    stroke: "#6679A9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2667 3.56641L16.4 3.56641",
    stroke: "#6679A9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.56667 3.56667C3.56667 2.76939 3.56667 2.37075 3.69692 2.0563C3.87058 1.63703 4.20369 1.30392 4.62296 1.13025C4.93742 1 5.33605 1 6.13333 1C6.93061 1 7.32925 1 7.6437 1.13025C8.06297 1.30392 8.39608 1.63703 8.56975 2.0563C8.7 2.37075 8.7 2.76939 8.7 3.56667C8.7 4.36394 8.7 4.76258 8.56975 5.07704C8.39608 5.49631 8.06297 5.82942 7.6437 6.00308C7.32925 6.13333 6.93061 6.13333 6.13333 6.13333C5.33605 6.13333 4.93742 6.13333 4.62296 6.00308C4.20369 5.82942 3.87058 5.49631 3.69692 5.07704C3.56667 4.76258 3.56667 4.36394 3.56667 3.56667Z",
    stroke: "#6679A9",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.7 12.1223C8.7 11.3251 8.7 10.9264 8.83025 10.612C9.00391 10.1927 9.33702 9.85958 9.75629 9.68591C10.0707 9.55566 10.4694 9.55566 11.2667 9.55566C12.0639 9.55566 12.4626 9.55566 12.777 9.68591C13.1963 9.85958 13.5294 10.1927 13.7031 10.612C13.8333 10.9264 13.8333 11.3251 13.8333 12.1223C13.8333 12.9196 13.8333 13.3182 13.7031 13.6327C13.5294 14.052 13.1963 14.3851 12.777 14.5587C12.4626 14.689 12.0639 14.689 11.2667 14.689C10.4694 14.689 10.0707 14.689 9.75629 14.5587C9.33702 14.3851 9.00391 14.052 8.83025 13.6327C8.7 13.3182 8.7 12.9196 8.7 12.1223Z",
    stroke: "#6679A9",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilters);
export default __webpack_public_path__ + "static/media/filters.aa1595f3777ddf9e8f3088a6932dbc4c.svg";
export { ForwardRef as ReactComponent };